import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SettingsPanel from './SettingsPanel';

interface WelcomeScreenProps {
  onStart: () => void;
}

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onStart }) => {
  const { t } = useLanguage();
  
  const handleStart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    console.log('🚀 WelcomeScreen - handleStart called');
    onStart();
  };
  
  return (
    <div className="fixed inset-0 bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 z-40 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4 py-8">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-3xl p-6 sm:p-8 max-w-3xl mx-auto w-full">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 mx-auto bg-blue-500/20 rounded-full flex items-center justify-center mb-4">
              <svg className="w-8 h-8 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.4 4.4 0 003 15z"></path>
              </svg>
            </div>
            <h1 className="text-3xl font-bold mb-3 text-white">{t.welcomeTitle}</h1>
            <p className="text-white/80 leading-relaxed mb-6">
              {t.welcomeSubtitle}
            </p>
          </div>

          {/* Settings Panel */}
          <SettingsPanel showTitle={false} />

          {/* Start button */}
          <div className="mt-8 text-center">
            <button 
              onClick={handleStart}
              className="bg-blue-500 hover:bg-blue-600 text-white px-8 py-3 rounded-xl font-medium transition-colors duration-200 inline-flex items-center gap-2"
            >
              <span>{t.welcomeButton}</span>
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
